import { createContext, useContext, useState, useEffect } from 'react';

const MobileThemeContext = createContext({ theme: 'dark', isDark: true, toggleTheme: () => {} });

// CSS variable values for each theme
const THEME_VARS = {
  dark: {
    '--m-bg': '#1a1a1a',
    '--m-bg-card': '#2a2a2a',
    '--m-bg-elevated': '#333333',
    '--m-bg-input': '#2a2a2a',
    '--m-text': '#ffffff',
    '--m-text-body': '#d1d5db',
    '--m-text-secondary': '#9ca3af',
    '--m-text-muted': '#6b7280',
    '--m-border': '#374151',
    '--m-border-light': '#4b5563',
    '--m-hover': '#333333',
    '--m-shadow': 'rgba(0,0,0,0.3)',
  },
  light: {
    '--m-bg': '#f1f5f9',
    '--m-bg-card': '#ffffff',
    '--m-bg-elevated': '#e2e8f0',
    '--m-bg-input': '#ffffff',
    '--m-text': '#0f172a',
    '--m-text-body': '#334155',
    '--m-text-secondary': '#475569',
    '--m-text-muted': '#94a3b8',
    '--m-border': '#cbd5e1',
    '--m-border-light': '#e2e8f0',
    '--m-hover': '#e2e8f0',
    '--m-shadow': 'rgba(0,0,0,0.08)',
  },
};

export const MobileThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('mobile-theme') || 'dark'; }
    catch { return 'dark'; }
  });

  useEffect(() => {
    try { localStorage.setItem('mobile-theme', theme); } catch {}

    // Apply CSS variables to :root so portals (Select, Dialog, etc.) inherit them
    const root = document.documentElement;
    const vars = THEME_VARS[theme] || THEME_VARS.dark;
    Object.entries(vars).forEach(([key, value]) => root.style.setProperty(key, value));
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  const isDark = theme === 'dark';

  const themeClasses = isDark ? 'mobile-dark' : 'mobile-light light';

  return (
    <MobileThemeContext.Provider value={{ theme, isDark, toggleTheme }}>
      <div className={themeClasses}>
        {children}
      </div>
    </MobileThemeContext.Provider>
  );
};

export const useMobileTheme = () => useContext(MobileThemeContext);
